import { render, staticRenderFns } from "./AddSplitRevenueModal.vue?vue&type=template&id=cacd7b3a&scoped=true"
import script from "./AddSplitRevenueModal.vue?vue&type=script&lang=ts"
export * from "./AddSplitRevenueModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacd7b3a",
  null
  
)

export default component.exports